import React from 'react';

import CircledDottedScheme9 from 'components/Schemes/CircledDottedScheme/9dots/CircledDottedScheme9';

const schemeItems = [
  'Patient profile',
  'Documentation management',
  'Insurance management',
  'Appointment management',
  'E-prescribing',
  'Clinical (pediatric) workflows',
  'Medical templates',
  'Reporting and analytics',
  'Secure data exchange',
];

export const TimelineScheme = () => (
  <CircledDottedScheme9 items={schemeItems} innerTitle="General features" containerClass="dotted-scheme" />
);
